import { render, staticRenderFns } from "./ProcessSettings.vue?vue&type=template&id=c48f29de&"
import script from "./ProcessSettings.vue?vue&type=script&lang=js&"
export * from "./ProcessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports